<template>
    <div class="container img_backgrond">
        <div class="row">
            <div class="col-lg-4 offset-lg-4 col-sm-6 offset-sm-3 col-xs-10 offset-xs-1 login-content mt-5">
                <div class="row">
                    <div class="col-sm-12 mt-4">
                        <h2 class="text-center">
                            <router-link :to="{ name: 'login' }"><img src="../../img/id-plein.png" alt="Logo"></router-link>
                        </h2>
                    </div>
                    <div class="col-sm-12 mt-4">
                        <h3 class="page-name text-center">{{ uLang('app.reset_password') }}</h3>
                    </div>
                </div>
                <form class="form-horizontal" enctype="multipart/form-data" @submit.prevent="reset" @keydown="form.errors.clear($event.target.name)">
                    <div class="form-group" v-bind:class="{ 'has-error' : form.errors.has('email') }">
                        <label for="email">{{ uLang('app.email') }}</label>
                        <input type="text" class="form-control" name="email" v-model="form.email" required>
                        <span class="help-block" v-if="form.errors.has('email')" v-text="form.errors.get('email')"></span>
                    </div>

                    <div class="form-group" v-bind:class="{ 'has-error' : form.errors.has('password') }">
                        <label for="password">{{ uLang('app.password') }}</label>
                        <input type="password" class="form-control" name="password" v-model="form.password" required>
                        <span class="help-block" v-if="form.errors.has('password')" v-text="form.errors.get('password')"></span>
                    </div>

                    <div class="form-group" v-bind:class="{ 'has-error' : form.errors.has('password_confirmation') }">
                        <label for="password_confirmation">{{ uLang('app.password') }}</label>
                        <input type="password" class="form-control" name="password_confirmation" v-model="form.password_confirmation" required>
                        <span class="help-block" v-if="form.errors.has('password_confirmation')" v-text="form.errors.get('password_confirmation')"></span>
                    </div>

                    <div class="form-group">
                        <input :disabled="form.busy" type="submit" :value="uLang('app.reset')" class="btn btn-brand btn-block" />
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import Form from '~/Form/Form'
import { SuccessAlert, ErrorAlert, InternalServerErrorAlert } from "~/Swals";

export default {
    name: "resetpassword",
    data() {
        return {
            form: new Form({
                token: '',
                email: '',
                password: '',
                password_confirmation: ''
            })
        }
    },
    methods: {
        async reset () {
            this.form.token = this.$route.params.token

            this.form.post('/api/password/reset').then((data) => {
                new SuccessAlert({ text: data.message }).show();

                this.$router.push({ name: 'login'});
            }).catch((error) => {
                if(error.response.status == 422) {
                    new ErrorAlert({ text: error.response.data.message }).show()
                    return
                }

                new InternalServerErrorAlert({ text: uLang('app.unknown_error') }).show()
            });
        }
    },
}
</script>
<style lang="scss" scoped>
.has-error {
    color: red;
    input {
        border-color: red;
    }
}
.login-content {
    margin-top: 7%;
    margin-bottom: 7%;
    padding-bottom: 20px;
    box-shadow: 0 0 30px #ccc;
    background-repeat: no-repeat;
    background-size: 100% 100%;
}
.img_backgrond {
    background-image: url("../../img/pages/Login-03-01.png");
    background-size: cover;
    height: 100vh;
    width: 100%;
}
label{
    font-size: 14px !important;
}
::-webkit-input-placeholder {
    font-size:14px;
}
.user-message {
    padding: 15px 0;
    font-size: 14px;
    color: #777;
}
</style>
